module.exports = __webpack_public_path__ + "img/no_activity.b99f7e7a.svg";